export const HOT_OFFERS_DEPARTURE_CITY_STORAGE_KEY =
  'free-avia:hot-offers-departure-city';

export const emojiMap: Record<string, string> = {
  // Turkey
  AYT: '🏖️', // Antalya
  IST: '🕌', // Istanbul
  ANK: '🏛️', // Ankara
  GZP: '🏝️', // Alanya

  // Georgia
  KUT: '🌄', // Kutaisi
  TBS: '🏰', // Tbilisi
  BUS: '🏖️', // Batumi

  // South Korea
  SEL: '🛍️', // Seoul
  CJU: '🌋', // Jeju
  PUS: '🏖️', // Busan
  KWJ: '🎨', // Gwangju

  // UAE
  AUH: '🕌', // Abu Dhabi
  DXB: '🏙️', // Dubai
  SHJ: '🏜️', // Sharjah

  // Uzbekistan
  NCU: '🖼️', // Nukus
  TAS: '🌳', // Tashkent
  FEG: '🍉', // Fergana
  SKD: '🕌', // Samarkand

  // Thailand
  HKT: '🏝️', // Phuket
  BKK: '🌆', // Bangkok

  // United States
  JFK: '🗽', // New York
  MIA: '🌴', // Miami
  LAX: '🎬', // Los Angeles
  IAD: '🏛️', // Washington
  SFO: '🌁', // San Francisco
  ORD: '🌆', // Chicago

  // Spain
  MAD: '🏰', // Madrid
  BCN: '🌊', // Barcelona

  // Malaysia
  KUL: '🌇', // Kuala Lumpur
  LGK: '🌴', // Langkawi
};
